<template>
  <div class="page_outposts">
    <h1>Hlídky</h1>
    <div class="actions">
      <input type="number" v-model="newOutpostNumber" min="1" max="100" />
      <button @click="add" class="add" title="Nová hlídka">
        <i class="fa fa-plus"></i>
      </button>
      <button @click="exportAll" class="export" title="Exportovat všechny účastníky">
        <i class="fa fa-file-export"></i>
      </button>
    </div>
    <tabloid name="outposts" :columns="columns" :data="map">
      <template v-slot:id="{ value }">{{ value }}. PH</template>
      <template v-slot:city="{ row }">
        <inputer :paths="['outposts', row.id, 'city']" />
      </template>
      <template v-slot:leaderId="{ row }">
        <inputerSelect :paths="['outposts', row.id, 'leaderId']" :items="row.availableLeaders">
          <template v-slot:default="props">{{ props.item != null ? props.item.name : "Zvolte velitele" }}</template>
          <template v-slot:item="props">{{ props.item.name }}</template>
        </inputerSelect>
      </template>
      <template v-slot:accommodationStartAt="{ row }">
        <inputerDate :paths="['outposts', row.id, 'accommodationStartAt']" :time="true" />
      </template>
      <template v-slot:wave="{ row }">
        <inputerNumber :paths="['outposts', row.id, 'wave']" :min="0" />
      </template>
      <template v-slot:additionalParticipantPrice="{ row }">
        <inputerNumber :paths="['outposts', row.id, 'additionalParticipantPrice']" />
      </template>
      <template v-slot:actions="{ row }">
        <button class="remove" title="Odebrat hlídku" @click="remove(row)">
          <i class="fa fa-times"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { _ } from "../../extend";
import tabloid from "../../components/tabloid.vue";
import inputer from "../../components/inputer.vue";
import inputerNumber from "../../components/inputer-number";
import inputerSelect from "../../components/inputer-select.vue";
import inputerDate from "../../components/inputer-date.vue"

export default {
  name: "outposts",
  components: {
    tabloid,
    inputer,
    inputerNumber,
    inputerSelect,
    inputerDate,
  },
  data: () => ({
    newOutpostNumber: 1,
    columns: {
      id: { title: "Hlídka" },
      city: { title: "Město" },
      leaderId: { title: "Velitel" },
      accommodationStartAt: { title: "Spuštění registrace ubytování" },
      paymentRemains: { title: "Zbývá zaplatit" },
      responsiblePerson: { title: "Zodpovědná osoba" },
      responsiblePersonEmail: { title: "Zodpovědná osoba - email" },
      responsiblePersonPhone: { title: "Zodpovědná osoba - telefon" },
      participantCount: { title: "Celkový počet účastníků" },
      wave: { title: "Vlna na jídlo" },
      quote: { title: "Kvóta na ubytování", headerAttributes: { title: 'Celková přiznaná kvóta +- poslaná kvóta.' }  },
      additionalParticipantPrice: { title: "Přidaná cena", headerAttributes: { title: 'Každý účastník této hlíkdy bude mít cenu vyšší o zadanou hodnotu (nebo nižší při záporné hodnotě).' } },
      actions: { title: " " },
    },
  }),
  computed: {
    ...mapState(["outposts", "users", "participants"]),
    map() {
      const result = _.select(this.outposts, o => {
          const outpost = { ...o };
          outpost.availableLeaders = _.filter(
            this.$store.state.users,
            user =>
              user.id == outpost.leaderId ||
              (user.role == "User" && !_.any(this.$store.state.outposts, o => o.leaderId == user.id)));
          outpost.responsiblePerson = this.$store.state.participants[outpost.responsiblePersonId] || {};
          outpost.responsiblePerson = `${outpost.responsiblePerson.name || ''} ${outpost.responsiblePerson.surname || ''}`;
          outpost.leader = this.$store.state.users[outpost.leaderId];
          outpost.responsiblePersonEmail = outpost.responsiblePersonEmail || (outpost.leader && outpost.leader.email) || '';
          outpost.responsiblePersonPhone = outpost.responsiblePersonPhone || (outpost.leader && outpost.leader.phone) || '';
          return outpost;
        });

      return result;
    },
  },
  methods: {
    add() {
      if (this.outposts[this.newOutpostNumber] !== undefined) {
        this.$store.commit("notify", {
          level: "warning",
          text: "Hlídka s tímto číslem již existuje!"
        });
        return;
      }

      this.$store.commit("update", {
        paths: ["outposts", this.newOutpostNumber],
        value: {
          id: this.newOutpostNumber,
          city: "",
          leaderId: null,
          responsiblePersonId: null,
          responsiblePersonEmail: null,
          responsiblePersonPhone: null,
          participantCount: 0,
          paymentRemains: 0,
          accommodationStartAt: null,
          wave: null
        }
      });
    },
    exportAll() {
      this.$store.dispatch("exportAdmin");
    },
    remove(outpost) {
      if (!confirm(`Opravdu chcete odebrat ${outpost.id}. PH - ${outpost.city}? Odeberete tím současně všechny její účastníky, týmy a další přidružené objekty!`))
        return;

      this.$store.commit("remove", {
        paths: ["outposts", outpost.id]
      });
    }
  }
};
</script>

<style lang="sass">
@import ../../sass/_components

.page_outposts
  @include table_view()
  .actions
    input
      @include input-base()
      @include first-input()
    button.add
      @include last-input()
    button.export
      @include button-secondary()
      margin-left: 0.5rem
  .remove
    @include button-danger()
</style>
